import { OnlinetestModel } from 'projects/core/src/lib/models/onlinetest.model';
import { BaseModel } from './base.model';
import { Deserializable } from './deserializable';

export class PartnerModel extends BaseModel implements Deserializable {

  // columns
  name: string;
  active_onlinetests: number;

  // relations
  onlinetests: Array<OnlinetestModel> = [];

  deserialize(input: any): this {
    Object.assign(this, input);
    // onlinetests
    let onlinetests = null;
    if (this.onlinetests !== null && this.onlinetests !== undefined) {
      onlinetests = [];
      this.onlinetests.forEach((onlinetest: OnlinetestModel) => {
        onlinetests.push(new OnlinetestModel().deserialize(onlinetest));
      });
    }
    this.onlinetests = onlinetests;
    return this;
  }

}
